import appApi from '../../../../../api/app-api';
import { SalaryHistoryDbType } from '../../../../../api/types/accountants/salary-history/salary-history.type';

export const getProfessorSalaryOperations = async (
  userId: number,
  startDate: Date,
  endDate: Date,
  setSalariesData: (data: SalaryHistoryDbType[]) => void,
) => {
  try {
    const response = await appApi.getProfessorSalaryHistory(
      userId,
      startDate,
      endDate,
    );
    if (response.data.ok) {
      setSalariesData(response.data.body);
    } else {
      console.error('Failed to fetch professor salary history');
      setSalariesData([]);
    }
  } catch (error) {
    console.error('Error fetching professor salary history:', error);
    setSalariesData([]);
  }
};
